import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Card , Typography} from '@mui/material';
import axios from 'axios';
import 'lightbox2/dist/css/lightbox.css';
import 'lightbox2/dist/js/lightbox.js';
//import './lightbox-custom.css'; // Import your custom CSS
//import '.styles/lightbox-custom.css'; // Import your custom
import '../components/styles/lightbox-custom.css'; // Import your custom
import BASE_URL from '../config';
const ThumbnailGallery = () => {
  const { albumId } = useParams();
  const [thumbnails, setThumbnails] = useState([]);
  const [albumName, setAlbumName] = useState('');

  /* useEffect(() => {
    axios.get(`https://apiviztech.in:6100/api/albums/${albumId}/thumbnails`)
      .then(response => setThumbnails(response.data))
      .catch(error => console.error('Error fetching thumbnails:', error));
  }, [albumId]);
 */  
// Fetch thumbnails and album name
useEffect(() => {
  const fetchAlbumData = async () => {
    try {
      const [thumbnailResponse, albumResponse] = await Promise.all([
        axios.get(`${BASE_URL}/api/albums/${albumId}/thumbnails`),
        axios.get(`${BASE_URL}/api/albums/${albumId}`)
      ]);
      setThumbnails(thumbnailResponse.data);
      setAlbumName(albumResponse.data.album_name);
    } catch (error) {
      console.error('Error fetching album data:', error);
    }
  };

  fetchAlbumData();
}, [albumId]);

  useEffect(() => {
    // Initialize Colorbox using window.$
    if (thumbnails.length > 0 && window.$) {
      window.$('.thumbnail-link').colorbox({
        rel: 'gallery',
        slideshow: true,
        slideshowSpeed: 3000,
        transition: 'elastic',
        width: '80%',
        height: '80%',
        photo: true,
        closeButton: true,
        current: 'Image {current} of {total}',
        previous: 'Previous',
        next: 'Next',
      });
    }
  }, [thumbnails]);

  return (
    <div style={{ padding: '20px' }}>
    {/* Album Name Display */}
    <Typography
      variant="h4"
      align="center"
      gutterBottom
      style={{
        fontWeight: 'bold',
        color: '#1976d2',
        textTransform: 'uppercase',
        fontStyle: 'italic',
      }}
    >
      {albumName}
    </Typography>
    
    
    <Grid
    container
    spacing={2}
    style={{
      marginTop: '20px',
      padding: '10px',
    }}
  >
    {thumbnails.map((thumbnail, index) => {
      // Extract the file name from the thumbnail path
      //const fileName = thumbnail.split('/').pop();

      return (
        
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Card style={{ padding: '8px' }}>
            
            <div
              style={{
                width: '100%',
                height: '200px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                borderRadius: '8px',
                backgroundColor: '#f0f0f0',
              }}
            >
              {/* Link to full-size image using only the file name */}
              <a
                href={`${BASE_URL}/uploads/photo_gallery${thumbnail}`}
                data-lightbox="gallery"
                data-title={`Image ${index + 1}`}
                className="thumbnail-link"
              >
                <img
                  src={`${BASE_URL}/uploads/thumbnails${thumbnail}`}
                  alt={`Thumbnail ${index + 1}`}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                    cursor: 'pointer',
                  }}
                />
              </a>
            </div>
          </Card>
        </Grid>
        
      );
    })}
  </Grid>
</div>
  );
};

export default ThumbnailGallery;
